(function() {
  'use strict';

  angular
    .module('contentPlayer.contentPlayerCtrl',
      ['factories.playerControls', 'factories.navigationFactory', 'factories.authProvider',
        'factories.contentCache', 'factories.nativeBridge', 'factories.quizAnswerStorage',
        'factories.durationTrackingFactory', 'factories.mobileHelper', 'factories.spinnerHelper', 'factories.alert'])
    .controller('ContentPlayerCtrl', ContentPlayerCtrl);

  ContentPlayerCtrl.$inject = ['$scope', '$http', '$rootScope', '$routeParams', '$timeout', '$location', 'Storage',
    'PlayerControls', 'ContentCache', 'NativeBridge', 'Utils', 'QuizAnswerStorage', 'DurationTrackingFactory',
    'MobileHelper', 'Alert', 'ContentPlayerService', 'Navigation', 'Auth', 'Sension', 'SpinnerHelper', 'mtypes',
    'gettextCatalog', 'translationService', 'gettext', '$modal', '$q', '$modalStack'];

  function ContentPlayerCtrl($scope, $http, $rootScope, $routeParams, $timeout, $location, Storage,
                             PlayerControls, ContentCache, NativeBridge, Utils, QuizAnswerStorage, DurationTrackingFactory,
                             MobileHelper, Alert, ContentPlayerService, Navigation, Auth, Sension, SpinnerHelper, mtypes,
                             gettextCatalog, translationService, gettext, $modal, $q, $modalStack) {
    $scope.lastLoadStep = 'controller loaded';

    var cachingLookAheadDepth = 3;
    var currentView;
    var slideTrackingStarted = false;
    var completedCModuleIncludingLastSlide = false;
    var deviceSupportsSension = false;
    var slideNotAvailable = false;
    var lastSlide;
    var translate = translationService.sprintf;
    var viewMapping = {
      FirstSlideInfo: 'contentPlayer/cModuleIntro.html',
      LastSlideInfo: 'contentPlayer/cModuleOutro.html',
      QuizFirstSlideInfo: 'quiz/quizIntro.html',
      QuizLastSlideInfo: 'quiz/quizOutro.html',
      VideoSlideInfo: { uri: 'video/video.html', spinner: true, customReady: true },
      QuizQuestionSlideInfo: { uri: 'quiz/quizMain.html', spinner: true, customReady: true },
      YouTubeSlideInfo: { uri: 'video/youtubeVid.html', spinner: true, customReady: true },
      PPTVideoSlideInfo: { uri: 'video/video.html', spinner: true, customReady: true },
      PPTImageSlideInfo: { uri: 'ppt/pptImage.html', spinner: true, customReady: true },
      NewMultiPageSlideInfo: { uri: 'newDocument/newDocument.html' },
      BoxPreview: { uri: 'boxPreview/boxPreviewContainer.html' },
      SurveyFirstSlideInfo: 'survey/surveyIntro.html',
      SurveyLastSlideInfo: 'survey/surveyOutro.html',
      SurveyQuestionSlideInfo: { uri: 'survey/surveyMain.html', spinner: true, customReady: true },
      ScoSlideInfo: 'scorm/scormContainer.html',
      ScoQuizSlideInfo: 'scorm/scormContainer.html'
    };

    $scope.cModule = null;
    $scope.narrationTemplate = null;
    $scope.currentSlide = null;
    $scope.slides = null;
    $scope.quizIdAmountOfQuestions = null;
    $scope.quizInfo = null;
    $scope.playerControls = PlayerControls;
    $scope.navigation = Navigation;
    $scope.quizAnswerStorage = QuizAnswerStorage;
    $scope.isPreview = ContentPlayerService.isPreview;
    $scope.cModuleId = $routeParams.cModuleId;
    $scope.courseId = $routeParams.courseId;
    $scope.slideTemplate = '';
    $scope.reloadHandler = {};
    $scope.yammerInfo = {};
    $scope.sensionEnabledDuringCModule = false;
    $scope.slideDisabled = false;

    Utils.hideStatusBar();
    gettextCatalog.setCurrentLanguage('en');

    if (angular.isUndefined($scope.thumbModel))
      $scope.thumbModel = { thumbs: null };

    if (angular.isUndefined($scope.cModuleModel))
      $scope.cModuleModel = { cModuleTitle: '' };

    if (angular.isUndefined($scope.courseModel))
      $scope.courseModel = {};

    if ($scope.isPreview)
      QuizAnswerStorage.setPreviewMode();


    var accountInfoDereg = $rootScope.$watch('accountInfo', function(newValue) {
      if ($scope.account && $scope.account.features) {
        $scope.languageFeature = !!~$scope.account.features.indexOf(mtypes.featureEntry.localization);
        return;
      }

      if (!newValue || !newValue.features) {
        $scope.languageFeature = false;
        return;
      }
      $scope.languageFeature = !!~newValue.features.indexOf(mtypes.featureEntry.localization);
    });

    $scope.inTrainerMode = $location.search().hideNavigationControls === '1';

    function loadCModule() {
      $scope.lastLoadStep = 'starting to load cModule';
      SpinnerHelper.showLoadingSpinner();
      Storage.setValue('playerLoaded', 1);
      var startParams = { cModuleId: $scope.cModuleId, courseId: $scope.courseId };

      setMindflashUserAs();

      var frameId = $location.search().frameId;
      if (frameId) {
        startParams.frameId = frameId;
      }

      ContentPlayerService.start(startParams, function loadCb(result) {
        if ($scope.inTrainerMode && window && window.parent && window.parent.__mf_interop__playerInfo) {
          window.parent.__mf_interop__playerInfo(result.playerInfo);
        }

        $scope.lastLoadStep = 'Received data for cModule load from server';
        SpinnerHelper.hideAllSpinners();

        gettextCatalog.setCurrentLanguage($scope.languageFeature && result.playerInfo.course ? result.playerInfo.course.language || 'en' : 'en');

        if (result.playerInfo.status === mtypes.cModuleStateStatus.missedCompletionDeadline) {
          $scope.lastLoadStep = 'Missed deadline, exiting player';
          $scope.cModuleModel.trainerEmail = result.playerInfo.course.trainerEmail;
          Alert.show('Module Not Available', ' The deadline for your module has expired. Please contact your trainer at: ' +
            $scope.cModuleModel.trainerEmail + ' if you would like to re-take this module.');
          Navigation.exitPlayer();
          $location.path('#/dash');
          return;
        }

        if (result.playerInfo.cModule.type === mtypes.cModuleType.live) {
          $scope.lastLoadStep = 'Live training, exiting player';
          $scope.cModuleModel.trainerEmail = result.playerInfo.course.trainerEmail;
          Alert.show('Live Training', 'Live training cannot be taken online.');
          Navigation.exitPlayer();
          $location.path('#/dash');
          return;
        }

        createCacheSlideDownloadJobs(result);
      }, function errorCb(error) {
        $scope.lastLoadStep = 'Received an error loading module data';
        if (!error || !error.isSingleSlidePreviewRoute) {
          return;
        }

        // For GoodData if the cModule is deleted or archived we need to custom handle and show the slide
        // not available message instead of an alert/redirection to the dashboard.
        $scope.navigation.init({
          numUnlockedSlides: 0,
          numSlides: 0,
          playerType: Navigation.playerTypes.trainerPreviewGoodData
        });
        Navigation.state = Navigation.states.ready;
        $scope.slideTemplate = 'contentPlayer/slideNotAvailable.html';
      });
    }

    function writeUnsavedFrameDurations() {
      if (!Auth.userIsLoggedIn() || $scope.isPreview || !completedCModuleIncludingLastSlide) {
        return;
      }

      var unsavedIntervals = DurationTrackingFactory.getAllUnsavedIntervals();
      if (!unsavedIntervals.length) {
        return;
      }

      ContentPlayerService.writeFrameDurations($scope.cModuleId, unsavedIntervals);
      DurationTrackingFactory.clear();
    }

    function setupSensionCallback() {
      Sension.setupSlideCallback(function(params) {
        if (slideTrackingStarted) {
          $scope.slideDisabled = Sension.faceHidden();

          if (!Sension.faceHidden() && !$scope.isPreview && (!$scope.completionInfo || completedCModuleIncludingLastSlide)) {
            DurationTrackingFactory.startDurationTracking($scope.currentSlide.id);
          } else {
            DurationTrackingFactory.stopDurationTracking();
          }
        }

        // Callback is cleared from JS-native bridge once it's called so set it up again.
        setupSensionCallback();
      });
    }

    function createCacheSlideDownloadJobs(result) {
      $scope.lastLoadStep = 'Creating cache slide download jobs';
      ContentCache.createCacheSlideDownloadJobs(result.playerInfo.slides, function() {
        $scope.lastLoadStep = 'Received callback from creating cache slide download jobs';
        $scope.slides = result.playerInfo.slides;
        $scope.cModule = result.playerInfo.cModule;
        cacheTrainerPhoto();
        $scope.courseModel = result.playerInfo.course;
        $scope.cModuleModel.cModuleTitle = $scope.cModule.name;
        $scope.cModuleModel.canContactTrainer = $scope.cModule.canContactTrainer;
        $scope.cModuleModel.trainerEmail = $scope.cModule.trainerEmail;
        result.thumbs.slidesLength = result.playerInfo.slides.length;
        $scope.thumbModel.thumbs = result.thumbs;
        $scope.quizIdAmountOfQuestions = result.playerInfo.quizIdAmountOfQuestions;
        $scope.quizInfo = result.playerInfo.quizInfo;
        QuizAnswerStorage.setCModuleStateId(result.playerInfo.cModuleStateId);

        $scope.yammerInfo.userCanSendYam = result.playerInfo.userCanSendYam;
        var showNavigation = parseInt($location.search().navigation);
        var frameId = parseInt($location.search().frameId);
        var slides = result.playerInfo.slides;
        var slideFromQueryStringFrameId = _.findWhere(slides, { id: frameId });
        slideNotAvailable = $scope.isPreview && !isNaN(frameId) && !slideFromQueryStringFrameId;
        var startSlideIndex = ($scope.isPreview && slideFromQueryStringFrameId) ?
          slides.indexOf(slideFromQueryStringFrameId) : result.playerInfo.currentSlideIndex;

        var trainerPreviewRoles = [Auth.userRoles.owner, Auth.userRoles.trainer, Auth.userRoles.administrator, Auth.userRoles.manager];
        var trainerAsUserPreviewRoles = [Auth.userRoles.owner, Auth.userRoles.trainer, Auth.userRoles.administrator, Auth.userRoles.manager, Auth.userRoles.reporter, Auth.userRoles.teamLead];
        var playerType = Navigation.playerTypes.trainee;
        if (trainerPreviewRoles.indexOf($scope.account.role) !== -1 && ContentPlayerService.isPreview) {
          if (showNavigation) {
            playerType = Navigation.playerTypes.trainerPreview;
            if (slideNotAvailable) {
              startSlideIndex = result.playerInfo.currentSlideIndex;
              slideNotAvailable = false;
            }
          } else {
            playerType = slideFromQueryStringFrameId || slideNotAvailable ? Navigation.playerTypes.trainerPreviewGoodData :
              Navigation.playerTypes.trainerPreview;
          }
        } else if (trainerAsUserPreviewRoles.indexOf($scope.account.role) !== -1 && $location.search().userId) {
          playerType = Navigation.playerTypes.trainerAsUserPreview;
        } else if ($scope.account.role === Auth.userRoles.sme) {
          playerType = Navigation.playerTypes.smePreview;
        } else if ($scope.account.role === Auth.userRoles.anonymous) {
          playerType = Navigation.playerTypes.public;
        }

        setCModuleModified($scope.cModule.lastModified);

        if (result.playerInfo.completionInfo) {
          $scope.setCompletionInfo(result.playerInfo.completionInfo);
          completedCModuleIncludingLastSlide = true;
        } else {
          completedCModuleIncludingLastSlide = $scope.isPreview;
        }

        Sension.init({
          hasCompletionInfo: !!$scope.completionInfo,
          isCompatible: deviceSupportsSension,
          isPreview: $scope.isPreview,
          sensionUsage: $scope.cModule.settings.sensionUsage
        });
        $scope.sensionEnabledDuringCModule = Sension.enabled();

        $scope.navigation.init({
          numUnlockedSlides: startSlideIndex,
          numSlides: slides.length,
          playerType: playerType,
          completionRedirectUrl: result.playerInfo.completionRedirectURL,
          cModuleStateStatus: result.playerInfo.status
        });

        if (result.playerInfo) {
          var reuseStateModalInstance = getReuseStateModalInstance(result.playerInfo.lastCompletedGrade);

          reuseStateModalInstance.result.then(function () {
            Navigation.exitPlayer();
            $location.path('#/dash');
          });
        }

        if (result.playerInfo.isStartingCModule && !$scope.isPreview) {
          Utils.kissmetrics('Started module', {
            useSension: Sension.enabled()
          });
        }

        Utils.kissmetrics('Viewed module', {
          isPreview: $scope.isPreview,
          useSension: Sension.enabled()
        });

        if (Sension.enabled()) {
          Sension.turnOn();
          $scope.slideDisabled = true;
          setupSensionCallback();
        }

        writeUnsavedFrameDurations();
      });
    }

    function getReuseStateModalInstance(lastCompletedGrade) {
      if(!lastCompletedGrade || $scope.isPreview) {
        return { result: $q.reject('ignore') };
      }

      return $modal.open({
        templateUrl: 'contentPlayer/reuseStateModal.html',
        controller: 'ReuseStateModalCtrl',
        backdrop: 'static',
        resolve: {
          lastCompletedGrade: function () {
            return lastCompletedGrade;
          }
        }
      });
    }

    function cacheTrainerPhoto() {
      var propertiesToCache = {
        trainerPhotoFullUrl: $scope.cModule.trainerPhotoFullUrl
      };
      ContentCache.cacheAssetsInJSON(propertiesToCache, function(data) {
        data = JSON.parse(data);
        for (var attrname in data) {
          $scope.cModule[attrname] = data[attrname];
        }
      });
    }

    function reloadSlide() {
      if ($scope.reloadHandler.reload) {
        $scope.reloadHandler.reload();
      }
    }

    $scope.onStaleFrameFound = function() {
      Alert.show(translate(gettext('Module Update in Progress')),
        translate(gettext('This module has been modified by the trainer and will be updated with the latest content.')));
      resetAndReloadCModule();
    };

    // Deprectated
    $scope.onStaleFrameStateFound = function() {
      Alert.show(translate(gettext('Answer already submitted')),
        translate(gettext('This question has already been answered. The page has been refreshed to reflect this update.')));
      resetAndReloadCModule();
    };

    function resetAndReloadCModule() {
      $scope.slideTemplate = null;  //Clear everything
      $scope.narrationTemplate = null;
      delete $scope.currentSlide;
      $scope.reloadHandler = {};
      Navigation.reset();
      loadCModule();
    }

    $scope.$watch('navigation.state', function(state) {
      Utils.hideStatusBar();
      PlayerControls.headerControlsVisible = false;
      PlayerControls.slideControlsVisible = false;

      if (state === Navigation.states.ready) {
        SpinnerHelper.hideAllSpinners();
        if (!MobileHelper.isTouch() || !MobileHelper.isMobileHeight()) {
          PlayerControls.headerControlsVisible = true;
          PlayerControls.slideControlsVisible = true;
        }
      }
    });

    $scope.$watch('navigation.slideIndex', function(slideIndex, oldValue) {
      if (!$scope.slides || angular.isUndefined(slideIndex) || slideIndex < 0)
        return;

      $scope.lastLoadStep = 'Slide index changed to ' + slideIndex + ' from ' + oldValue;
      Navigation.resetInterceptors();
      if (Navigation.state === Navigation.states.ready)
        Navigation.state = Navigation.states.loading;

      lastSlide = $scope.currentSlide;

      // this can cause issues be wary
      delete $scope.currentSlide;

      $scope.reloadHandler = {};
      $scope.slideTemplate = null;
      $scope.narrationTemplate = null;

      $rootScope.questionStyle = '';

      var currentSlide = $scope.slides[$scope.navigation.slideIndex];
      if (!currentSlide) throw Error('No slide found for slide index ' + $scope.navigation.slideIndex);
      var slideType = currentSlide.__type;

      currentView = slideNotAvailable ? 'contentPlayer/slideNotAvailable.html' : viewMapping[slideType];

      if (!currentView.uri)
        currentView = { uri: currentView };

      if (currentView.spinner)
        SpinnerHelper.showMinorSpinner();

      Navigation.intercept("canNavigate", function() {
        return false;
      });
      ContentCache.cacheLookAheadSlideData($scope.cModule, $scope.slides.slice($scope.navigation.slideIndex + 1, $scope.navigation.slideIndex + cachingLookAheadDepth + 1));

      $scope.lastLoadStep = 'About to prepare cache for slide';
      ContentCache.prepareCacheForSlide($scope.navigation.slideIndex + 1, currentSlide,
        receivedCachedSlideContent);
    });

    function receivedCachedSlideContent(data) {
      $scope.lastLoadStep = 'Have received cached slide content';
      Navigation.resetInterceptors();
      data = JSON.parse(data);
      var aggregateEngagement = null;
      if ($scope.sensionEnabledDuringCModule) {
        aggregateEngagement = Sension.getAggregateEngagement();
      }
      if (Sension.enabled()) {
        Sension.changedSlide(data.id);
      }
      $scope.currentSlide = data;
      if ($scope.currentSlide.narrationPath && $scope.currentSlide.__type !== 'PPTVideoSlideInfo' && !slideNotAvailable) {
        $scope.narrationTemplate = 'audio/audio.html';
      }
      replaceSlide($scope.currentSlide);

      var lastSlideFrameId = lastSlide && lastSlide.id;
      var lastSlideFrameDuration;
      if (!$scope.completionInfo && !$scope.isPreview) {
        lastSlideFrameDuration = DurationTrackingFactory.getFrameDuration(lastSlideFrameId);
        if (lastSlideFrameDuration)
          DurationTrackingFactory.cleanFrameDuration(lastSlideFrameId);

        if (Sension.enabled()) {
          Sension.getEngagementFromFramework(function(isEngaged) {
            if (isEngaged)
              DurationTrackingFactory.startDurationTracking($scope.currentSlide.id);
          });
        } else {
          DurationTrackingFactory.startDurationTracking($scope.currentSlide.id);
        }
        slideTrackingStarted = true;
      } else {
        DurationTrackingFactory.stopDurationTracking();
        slideTrackingStarted = false;
      }

      // advance progress for surveys even if the cModule is completed
      var surveySlideTypes = [mtypes.frameType.surveyIntroFrame, mtypes.frameType.surveyLastFrame, mtypes.frameType.surveyQuestionFrame];
      if ($scope.isPreview || !$scope.completionInfo || ($scope.completionInfo && ~surveySlideTypes.indexOf($scope.currentSlide.type))) {
        var progress = {
          engagementScore: aggregateEngagement
        };
        if (!$scope.isPreview && lastSlide) {
          progress.exitFrameId = lastSlideFrameId;
          if (lastSlideFrameDuration && (lastSlide.__type !== 'ScoSlideInfo' || lastSlide.__type !== 'ScoQuizSlideInfo'))   //Scorm sets its own duration, dont overwrite it
            progress.durationInterval = lastSlideFrameDuration.durationMilliseconds;
        }

        $scope.advanceSlideProgress(progress);
      } else if (!completedCModuleIncludingLastSlide) {
        writeUnsavedFrameDurations();

        // CModule is completed and we've written the last content slide's duration. Stop writing durations.
        var isLastSlideInCModule = ($scope.slides[$scope.slides.length - 1].id === $scope.currentSlide.id);
        if (isLastSlideInCModule) {
          completedCModuleIncludingLastSlide = true;
        }
      }

      $scope.slideTemplate = currentView.uri;

      Navigation.state = Navigation.states.loading;

      if (!currentView.customReady) {
        $scope.lastLoadStep = 'Not using custom ready so after timeout should set to ready and cancel failsafe timer.';
        $timeout(function() {
          Navigation.state = Navigation.states.ready;
          Navigation.showNavControls = true;
        }, 100);
      } else {
        $scope.lastLoadStep = 'Using custom ready so it\'s up to the individual slide\'s controller to set state to ready and cacel failsafe timer.';
      }
    }

    $scope.advanceSlideProgress = function(progress) {
      if ($scope.isPreview) {
        _.defaults(progress, {
          cModuleId: $scope.cModuleId,
          courseId: $scope.courseId,
          cModuleModificationTime: $scope.cModule.lastModified,
          quizScoresForCModuleCompletion: null,
          completedQuizScores: null
        });
      } else {
        _.defaults(progress, {
          cModuleId: $scope.cModuleId,
          courseId: $scope.courseId,
          enterFrameId: $scope.currentSlide.id,
          engagementScore: null
        });
      }

      if (lastSlide) {
        progress.exitFrameStateId = lastSlide.frameStateId;
        progress.exitFrameId = lastSlide.id;
      }

      ContentPlayerService.nextSlide(progress, progressSuccess, progressError);
    };

    function progressSuccess(result) {
      // Deprecate - remove when .NET player backend is removed
      if (result.frameIsStale)
        return $scope.onStaleFrameFound();

      if (ContentPlayerService.isPreview)
        return;

      if (result.cModuleCompleted)
        $scope.setCompletionInfo(result.cModuleCompleted);
      if (result.quizLastSlideInfo)
        $scope.setQuizLastSlideInfo(result.quizLastSlideInfo);
      if (result.quizCompleted)
        $scope.markQuizComplete($scope.currentSlide.quizId);

      // Deprecate - remove when .NET player backend is removed
      if (result.completionInfo)
        $scope.setCompletionInfo(result.completionInfo);

      // Deprecate - remove when .NET player backend is removed
      if (result.completedQuizzes && result.completedQuizzes.length > 0) {
        _.each(result.completedQuizzes, function(quiz) {
          $scope.setQuizLastSlideInfo(quiz);
          $scope.markQuizComplete(quiz.quizId);
        });
      }

      $scope.$broadcast('$progressProcessingCompleted');
    }

    function progressError(error) {
      if (error && error.data === "ContentModified") {
        $scope.onStaleFrameFound();
        return true;
      }
    }

    $scope.setCompletionInfo = function(cModuleCompletionInfo) {
      $scope.completionInfo = cModuleCompletionInfo;
    };

    $scope.setQuizLastSlideInfo = function(quizLastSlideInfo) {
      updateSlide(quizLastSlideInfo);
      if (quizLastSlideInfo.completed)
        $scope.markQuizComplete(quizLastSlideInfo.quizId);
    };

    $scope.markQuizComplete = function(quizId) {
      var slide;
      if ($scope.currentSlide && $scope.currentSlide.quizId == quizId)
        $scope.currentSlide.quizCompleted = true;

      for (var i = 0; i < $scope.slides.length; i++) {
        slide = $scope.slides[i];
        if (slide.quizId == quizId)
          slide.quizCompleted = true;
      }
    };

    function setCModuleModified(modified) {
      $http.defaults.headers.common['x-mindflash-cmodulelastmodified'] = modified;
    }

    function setMindflashUserAs() {
      var userId = $location.search().userId;

      if (userId) {
        $http.defaults.headers.common['X-Mindflash-As-User'] = userId;
      }
    }

    function replaceSlide(newSlide) {
      var slide;
      if (newSlide.id == $scope.currentSlide.id)
        $scope.currentSlide = newSlide;

      for (var i = 0; i < $scope.slides.length; i++) {
        slide = $scope.slides[i];
        if (slide.id != newSlide.id) continue;
        $scope.slides[i] = newSlide;
        return;
      }
    }

    function updateSlide(newSlide) {
      var slide;
      if ($scope.currentSlide && $scope.currentSlide.id == newSlide.id)
        $scope.currentSlide = _.extend({}, $scope.currentSlide, newSlide);

      for (var i = 0; i < $scope.slides.length; i++) {
        slide = $scope.slides[i];
        if (slide.id != newSlide.id) continue;
        $scope.slides[i] = _.extend({}, slide, newSlide);
        return;
      }
    }

    $scope.getCurrentQuizInfo = function() {
      var quizId = $scope.currentSlide.quizId;
      return _.find($scope.quizInfo, function(quizInfo) {
        return quizInfo.id == quizId;
      });
    };

    $scope.$on("FullScreenChanged", function(event, isFullScreen) {
      event.stopPropagation();

      $rootScope.mainbgColor = isFullScreen ? '#000000' : '#FFFFFF';
      $rootScope.fullScreen = isFullScreen;
    });

    function writeFrameDuration() {
      if (!$scope.currentSlide || !Auth.userIsLoggedIn() || $scope.isPreview || completedCModuleIncludingLastSlide) return;
      var frameDuration = DurationTrackingFactory.getFrameDuration($scope.currentSlide.id);
      DurationTrackingFactory.cleanFrameDuration($scope.currentSlide.id);

      ContentPlayerService.writeFrameDurations($scope.cModuleId, [frameDuration]);
    }

    $scope.showGenericContentError = function() {
      $scope.contentErrorModal = {
        message: translate(gettext('We\'ve encountered an error loading your content.')),
        redirectToDashboard: true,
        title: translate(gettext('Error Viewing Content'))
      };
      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();
      $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: $scope,
        backdrop: 'static'
      });
    };

    Sension.isCompatible(function(isCompatible) {
      $scope.lastLoadStep = 'Called back from Sension.isCompatible';
      deviceSupportsSension = isCompatible;

      NativeBridge.registerHandler("appReload", reloadSlide);

      $scope.account = Auth.getSelectedAccount();
      loadCModule();
    });


    $scope.$on('$destroy', function() {
      $modalStack.dismissAll();
      DurationTrackingFactory.stopDurationTracking();
      writeFrameDuration();
      slideTrackingStarted = false;

      Utils.showStatusBar();

      Navigation.reset();
      if ($scope.isPreview && $scope.quizAnswerStorage && $scope.quizAnswerStorage.clearPreviewAnswers) {
        $scope.quizAnswerStorage.clearPreviewAnswers();
      }
      accountInfoDereg();
    });
  }
})();